import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { ListingCoachFollowBtn } from "./ListingCoachFollowBtn";
import Link from "next/link";
import { buildUrlName, getInterestLabel } from "../../../../lib/generic";
import { ListingCoachSectionWrapper } from "./ListingCoachSectionWrapper";
import { ListingCoachHeaderWrapper } from "./ListingCoachHeaderWrapper";
import { ListingCoachHeaderSection } from "./ListingCoachHeaderSection";
import { ListingCoachNameStarWrapper } from "./ListingCoachNameStarWrapper";
import { ListingCoachNameFollowWrapper } from "./ListingCoachNameFollowWrapper";
import {
  BodyLargeVariant,
  BodySmallVariant,
  TitleLarge,
} from "../../../global/ui/typography";
import {
  AppRating,
  AppRatingDescription,
  ScoreStarRatingWrapper,
} from "../../../global/score/material";
import { ListingCoachAboutWrapper } from "./ListingCoachAboutWrapper";
import { ListingCoachImage } from "./ListingCoachImage";
import { ListingVerificationBadge } from "./ListingVerificationBadge";
import useIsRendered from "../../../../hooks/global/useIsRendered";
import { ListingCoachSectionBioWrapper } from "./ListingCoachSectionBioWrapper";
import { AppTextButton } from "../../../global/ui/buttons";
import { ListingCoachAboutHeader } from "./ListingCoachAboutHeader";
import { BioViewer } from "../../../specialist/material/coachAboutSection/BioViewer";

export const ListingCoachSection = () => {
  const listingData = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );
  const isRendered = useIsRendered();

  return (
    <ListingCoachSectionWrapper
      className={listingData.reviews ? "" : "lg:border-0"}
    >
      <ListingCoachHeaderWrapper>
        <ListingCoachHeaderSection>
          {listingData.user.featured ? (
            <Link
              className="relative"
              href={{
                pathname: "/specialist/[id]/[name]",
                query: {
                  id: listingData.user.id,
                  name: buildUrlName(listingData.user.name),
                },
              }}
            >
              <ListingCoachImage />
              {listingData.user?.verificationBadge && (
                <ListingVerificationBadge />
              )}
            </Link>
          ) : (
            <ListingCoachImage />
          )}

          <ListingCoachNameStarWrapper>
            <ListingCoachNameFollowWrapper>
              <BodyLargeVariant>{listingData.user.name}</BodyLargeVariant>
              <ListingCoachFollowBtn className="hidden lg:block" />
            </ListingCoachNameFollowWrapper>

            <ScoreStarRatingWrapper>
              <AppRating value={listingData.user.score} />
              <AppRatingDescription>
                {listingData.user.score.toFixed(1)}
              </AppRatingDescription>
            </ScoreStarRatingWrapper>
          </ListingCoachNameStarWrapper>
        </ListingCoachHeaderSection>

        <ListingCoachFollowBtn className="lg:hidden" />
      </ListingCoachHeaderWrapper>

      {isRendered && (
        <ListingCoachAboutWrapper>
          <ListingCoachAboutHeader>
            <TitleLarge>About</TitleLarge>

            <BodySmallVariant>
              {getInterestLabel(listingData.user.interest)} Coach
            </BodySmallVariant>
          </ListingCoachAboutHeader>

          <ListingCoachSectionBioWrapper>
            <BioViewer bio={listingData.user.bio} />

            {listingData.user.featured && (
              <Link
                href={{
                  pathname: "/specialist/[id]/[name]",
                  query: {
                    id: listingData.user.id,
                    name: buildUrlName(listingData.user.name),
                  },
                }}
              >
                <AppTextButton className={"p-0 h-5"}>
                  View full profile
                </AppTextButton>
              </Link>
            )}
          </ListingCoachSectionBioWrapper>
        </ListingCoachAboutWrapper>
      )}
    </ListingCoachSectionWrapper>
  );
};
